import React from 'react';
import { ErrorBoundary as ReactErrorBoundary, type FallbackProps } from 'react-error-boundary';

function Fallback({ error, resetErrorBoundary }: FallbackProps) {
    if (import.meta.env.DEV) console.error('App crash:', error);
    return (
        <div style={{ padding: 24 }}>
            <h1>Something went wrong.</h1>
            {import.meta.env.DEV && (
                <pre style={{ whiteSpace: 'pre-wrap' }}>{String(error?.stack || error?.message)}</pre>
            )}
            <button onClick={resetErrorBoundary}>Try again</button>
        </div>
    );
}

export function ErrorBoundary({
                                     children,
                                     resetKeys,
                                 }: {
    children: React.ReactNode;
    resetKeys?: unknown[];
}) {
    return (
        <ReactErrorBoundary FallbackComponent={Fallback} resetKeys={resetKeys}>
            {children}
        </ReactErrorBoundary>
    );
}
